
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivate,
} from '@angular/router';
import { AuthService, OccEndpointsService } from '@spartacus/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { UserInfoService } from '../spartacus/services/user-info.service';

@Injectable({ providedIn: 'root' })
export class SeqirusAuthGuard implements CanActivate {
  currentRoute = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private occ: OccEndpointsService,
    private userInfoService: UserInfoService,
    private cookieService: CookieService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const urlNoQuery = state.url.split('?')[0];
    const segments = urlNoQuery.split('/').filter(Boolean);
    this.currentRoute = segments.length ? segments[segments.length - 1] : '';
    const queryParams = route.queryParams;
    const isEnrollmentFlow =
      segments.includes('enrollment') && queryParams['email'] === 'true';

    const baseUrl = this.occ.getBaseUrl() ?? '';
    const isFlu360 = baseUrl.includes('seqirusb2b-flu360');
    const isUK = baseUrl.includes('seqirusb2b-uk');

    const visitorTypeCookieValid =this.userInfoService.isHealthcareVisitor();

    return this.authService.isUserLoggedIn().pipe(
      take(1),
      switchMap((isLoggedIn) => {
        //Preserve intended target for enrollment if unauthenticated
        if (!isLoggedIn && isEnrollmentFlow) {
          sessionStorage.setItem('navigateToUrl', this.currentRoute);
        }

        // Non-flu360 + bad visitor type → send to root
        if (!isFlu360 && !visitorTypeCookieValid) {
          sessionStorage.setItem('navigateToUrl', state.url);
          if (this.currentRoute !== '') {
            return of(this.router.parseUrl('/'));
          }
          return of(true);
        }

        // Not logged in → go to login
        if (!isLoggedIn) {
          if(isUK){
            return of(this.router.parseUrl('/homepage'));
          }else{
          return of(this.router.parseUrl('/login'));
          }
        }

        // Logged in → decide based on user info.
        // IMPORTANT: Do not block when user info is null (fresh reload).
        return this.userInfoService.getUserData().pipe(
          take(1),
          map((userdata) => {
            // ✅ If null (fresh reload), DO NOT block — allow activation.
            if (!userdata) {
              return true;
            }

            // Existing decision logic
            if (userdata.webEnabled) {
              // Allow navigation to requested route.
              return true;
            }

            // Not webEnabled → site-specific redirects
            if (isFlu360) {
              return this.router.parseUrl('/');
            }
            if (isUK) {
              return this.router.parseUrl('/register/join-account');
            }
            return true;
          }),
          catchError(() => of(this.router.parseUrl('/error-page')))
        );
      })
    );
  }
}
